var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-ajax-table-with-crud-actions',{attrs:{"id":_vm.id,"titles":_vm.titles,"props":_vm.props,"bus":_vm.bus,"actions":_vm.actions,"endpoint":_vm.endpoint,"endpoint-params":_vm.endpointParams,"edit-url":_vm.edit_url,"delete":_vm.canManage}})
}
var staticRenderFns = []

export { render, staticRenderFns }